<template>
  <div class="finishingScreen" :class="{ 'ac-bg-black': ac }">
    <header-component
      :is-soon="false"
      img-left=""
      img-right="/trocachip/img/access.png"
      class="header-component"
      :backRoute="false"
    />
    <div class="change_chip_container">
      <span
        class="finishingScreenPage_title"
        :class="{ 'ac-color-white': ac }"
        v-html="title"
      ></span>
      <div class="change_chip_carousel">
        <slick-carousel v-bind="carouselSettings">
          <div
            v-for="(info, index) in pageMessages"
            :key="index"
            class="barcode_inst_infos"
          >
            <img :src="getImageSrc(info.image)" />
            <span v-html="info.text" class="barcode_inst_info_text"></span>
          </div>
        </slick-carousel>
      </div>
      <div class="registered_info">
        <span
          class="description_info"
          :class="{ 'ac-color-white': ac }"
          v-html="finishingScreenPage.subInfo"
        ></span>
      </div>
      <div class="time_page_info">
        <p class="description_time_page" :class="{ 'ac-color-white': ac }">
          {{ formattedTime }}
        </p>
      </div>
    </div>

    <footer class="progress_line">
      <div class="progress_line_blue" :style="dinamicStyle"></div>
    </footer>
  </div>
</template>

<script>
import trackEvent from "@/services/trackEvent";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { mapState } from "vuex";
import HeaderComponent from "../components/HeaderComponent";
import BillingProfile from "../services/billingProfile";
import eSim from "../services/eSim";
import emailStatus from "../services/emailStatus";
import Order from "../services/order";

export default {
  name: "finishingScreen",
  components: {
    HeaderComponent,
    "slick-carousel": VueSlickCarousel,
  },
  data() {
    return {
      description: "",
      timerCounter: 0,
      pageMessages: [],
      carouselSettings: {
        arrows: false,
        autoplay: false,
        dots: true,
        draggable: false,
        infinite: false,
        swipe: true,
      },
      title: "",
      counterRetryEmailStatus: 0,
      counterRetryOrderService: 0,
      counterRetryReserve: 0,
      counterRetryChangeEmail: 0,
    };
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      document: (state) => state.document,
      config: (state) => state.config,
      customer: (state) => state.customer,
      initFlow: (state) => state.config["init_flow"],
      finishingScreenPage: (state) => state.config.finishingScreenPage || {},
      finishingTitles: (state) => state.config.finishingTitles,
      limitRetryEmailStatus: (state) => state.config.limitRetryEmailStatus,
      limitRetryOrderService: (state) => state.config.limitRetryOrderService,
      limitRetryChangeEmail: (state) => state.config.limitRetryChangeEmail,
      limitRetryReserva: (state) => state.config.limitRetryReserva,
      difficultCompleteExchangePage: (state) =>
        state.config.difficultCompleteExchangePage,
      pinToken: (state) => state.pinToken,
      reason: (state) => state.reason,
      pin: (state) => state.pin,
      code: (state) => state.code,
      timeToCallRetryChangeEmail: (state) =>
        state.config.timeToCallRetryChangeEmail,
      timeToCallRetryOrder: (state) => state.config.timeToCallRetryOrder,
      timeToCallRetryOrderPendingSibel: (state) =>
        state.config.timeToCallRetryOrderPendingSibel,
      timeToCallRetryEmailStatus: (state) =>
        state.config.timeToCallRetryEmailStatus,
      timeToCallRetryReserve: (state) => state.config.timeToCallRetryReserve,
      fullTimeLoading: (state) => state.config.fullTimeLoading,
      canReserve: (state) => state.canReserve,
      canOrder: (state) => state.canOrder,
      canChangeEmail: (state) => state.canChangeEmail,
      emailProtocol: (state) => state.emailProtocol,
      urlEsim: (state) => state.urlEsim,
      iccidEsim: (state) => state.iccidEsim,
    }),
    formattedTime() {
      const minutes = parseInt(this.timerCounter / 60);
      const seconds = parseInt(this.timerCounter % 60);

      let m = minutes.toString();
      if (m.length === 1) {
        m = `0${m}`;
      }

      let s = seconds.toString();
      if (s.length === 1) {
        s = `0${s}`;
      }

      return `${m}:${s}`;
    },
    dinamicStyle() {
      return {
        animation: `growWidth ${this.fullTimeLoading}s linear forwards`,
      };
    },
  },
  created() {
    this.sendTracker("screen_etapa1_processamento_processando_solicitacao");
    this.$store.dispatch("disableBack", true)
    this.pageMessages = this.config.processingStep;
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  },
  mounted() {
    this.startTimer();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    if (this.$route.params.changeEmail) {
      this.title = this.$route.params.title;
      this.updateEmail();
    } else {
      this.title = this.$route.params.title;
      this.timerCounter = this.$route.params.countTime;
      this.callReserveEsim();
    }
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  methods: {
    handleBeforeUnload(event) {
      // Cancel the event
      event.preventDefault();
      // Set the event.returnValue to display the confirmation message
      event.returnValue =
        "Seu pedido está em andamento. Deseja realmente sair?";
    },

    redirectToErrorPage() {
      this.$router.push({ name: "default-error" });
    },
    nextFlow(flowSelected) {
      this.$store.commit("flowSelected", flowSelected);
      this.$router.push({ name: "difficultCompleteExchange" });
    },
    getImageSrc(imageName) {
      return require("../assets/images/" + imageName);
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timerCounter <= this.fullTimeLoading) {
          this.timerCounter += 1;
        } else {
          this.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timerInterval);
    },
    async sendCustomDimension(dimension, value) {
            // Convert value to string if it's not already
            const strValue = String(value);

            // Replace spaces, asterisks, and parentheses
            const sanitizedValue = strValue
                .replace(/\s/g, '_')    // Replace spaces with underscores
                .replace(/\*/g, '_')     // Remove asterisks
                .replace(/[()]/g, '_');  // Remove parentheses - no need to escape inside []
            console.log("Sending " + dimension + ": " + sanitizedValue);
            const command = `decibelInsight("sendCustomDimension", "${dimension}", "${sanitizedValue}");`;
            console.log(command)
            window.eval(command);
        },
    updateEmail() {
      console.log(
        "CHANGE EMAIL" +
          this.canChangeEmail +
          "RESERVE " +
          this.canReserve +
          " ORDER " +
          this.canOrder
      );
      if (
        !this.canChangeEmail &&
        this.config.enable_reserve_order_one_time_use
      ) {
        if (this.emailProtocol != "") {
          console.log("Retomando o fluxo de alteração de email");
          this.postEmailStatus(this.emailProtocol);
        } else {
          console.log("Acesso indevido no fluxo de alteração de email");
          this.callReserveEsim();
        }
        return;
      }
      this.$store.dispatch("disallowReserve");
      BillingProfile.updateEmail(
        this.$route.params.email ? this.$route.params.email : ""
      )
        .then((response) => {
          const responseData = response.data;

          if (!responseData) return;

          if (responseData.interactionProtocol != "") {
            this.$store.dispatch("disallowChangeEmail");
            this.postEmailStatus(responseData.interactionProtocol);
          } else {
            this.$router.push({
              name: "timeOutEmail",
              params: {
                counter: this.timerCounter,
              },
            });
          }
        })
        .catch((e) => {
          console.error(e);
          this.counterRetryChangeEmail++;
          if (this.counterRetryChangeEmail != this.limitRetryChangeEmail) {
            console.log(this.timeToCallRetryChangeEmail);
            setTimeout(
              () => this.updateEmail(),
              this.timeToCallRetryChangeEmail
            );
          } else {
            if (this.customer.email) {
              this.$router.push({
                name: "timeOutEmail",
                params: {
                  counter: this.timerCounter,
                },
              });
            } else {
              this.$router.push({ name: "chipExchangeClosed" });
            }
          }
        });
    },
    postEmailStatus(interactionProtocol) {
      if (this.config.toggleEnableEmailStatus) {
      this.sendTracker("screen_etapa2_processamento_alterando_email");
      this.title = this.finishingTitles.updateEmailTitle;
      const interaction = {
        number: interactionProtocol,
        msisdn: this.customer.login,
      };

      emailStatus
        .emailStatus(interaction)
        .then((_) => {
          console.log(_);
          this.sendTracker("screen_etapa3_processamento_reservando_esim");
          this.title = this.finishingTitles.bookingEsinTitle;
          this.$store.dispatch("allowReserve");
          this.callReserveEsim();
        })
        .catch((_) => {
          console.error(_);
          this.counterRetryEmailStatus++;
          if (
            this.counterRetryEmailStatus != this.limitRetryEmailStatus &&
            _.response.status == 423
          ) {
            setTimeout(
              () => this.postEmailStatus(interactionProtocol),
              this.timeToCallRetryEmailStatus
            );
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleEmailStatus
            );
          }
        });
      } else {
          this.sendTracker("screen_etapa3_processamento_reservando_esim");
          this.title = this.finishingTitles.bookingEsinTitle;
          this.$store.dispatch("allowReserve");
          this.callReserveEsim();
      }
    },
    callReserveEsim() {
      console.log(
        "CHANGE EMAIL" +
          this.canChangeEmail +
          "RESERVE " +
          this.canReserve +
          " ORDER " +
          this.canOrder
      );
      if (!this.canReserve && this.config.enable_reserve_order_one_time_use) {
        if (this.urlEsim != "" && this.iccidEsim != "") {
          console.log("Retomando o fluxo de ordem");
          this.orderService(this.iccidEsim, this.urlEsim);
        } else {
          console.log("Acesso indevido no fluxo de reserva");
          this.redirectToErrorPage();
        }
        return;
      }
      eSim
        .reservaEsim()
        .then((response) => {
          this.title = this.finishingTitles.makingExchangeTitle;
          this.sendTracker("screen_etapa4_processamento_realizando_troca");
          if (!response.data)
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );

          this.$store.dispatch("urlEsim", response.data.url);
          this.$store.dispatch("iccidEsim", response.data.simCard.iccid);
          this.$store.dispatch("disallowReserve");
          this.$store.dispatch("allowOrder");
          this.orderService(response.data.simCard.iccid, response.data.url);
        })
        .catch(() => {
          this.counterRetryReserve++;
          if (this.counterRetryReserve != this.limitRetryReserva) {
            setTimeout(
              () => this.callReserveEsim(),
              this.timeToCallRetryReserve
            );
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );
          }
        });
    },
    orderService(iccid, urlEsim) {
      console.log(
        "CHANGE EMAIL" +
          this.canChangeEmail +
          "RESERVE " +
          this.canReserve +
          " ORDER " +
          this.canOrder
      );

      if ((!this.canOrder && this.config.enable_reserve_order_one_time_use) || this.counterRetryOrderService >= this.limitRetryOrderService) {
        console.log("Acesso indevido no fluxo de ordem");
        this.redirectToErrorPage();
        return;
      }
      this.sendTracker("screen_etapa6_processamento_finalizando");
      this.title = this.finishingTitles.finallyTitle;
      let acceptedBiometry = this.getAcceptedBiometry();
      this.sendCustomDimension('ICCID_TC', iccid);
      Order.getOrder(this.code, this.pinToken, iccid, this.reason, urlEsim, acceptedBiometry)
        .then((response) => {
          if (response.data.internalCode == "1") {
            this.$store.dispatch("protocol", response.data.protocol);
            this.$store.dispatch("disallowOrder");
            this.$router.push("/loadingProcess");
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.counterRetryOrderService++;

          if (
            error.response.status == 422 &&
            this.timerCounter <= this.fullTimeLoading
          ) {
            setTimeout(
              () => this.orderService(iccid, urlEsim),
              this.timeToCallRetryOrderPendingSibel
            );
          } else if (
            this.counterRetryOrderService != this.limitRetryOrderService &&
            this.timerCounter <= this.fullTimeLoading
          ) {
            this.title = this.finishingTitles.waitAminutinTitle;
            this.sendTracker("screen_etapa5_processamento_tempo_esgotado");
            setTimeout(
              () => this.orderService(iccid, urlEsim),
              this.timeToCallRetryOrder
            );
          } else {
            this.redirectToPageError(
              this.difficultCompleteExchangePage.subtitleOrderService
            );
          }
        });
    },
    getAcceptedBiometry() {
            if (this.config.parameterBiometryAccepted[this.customer.segment] && this.config.parameterBiometryAccepted[this.customer.segment].includes(this.customer.login.substring(0,2))) {
                return true;
            }
                return false;
    },
    redirectToPageError(description) {
      this.$router.push({
        name: "difficultCompleteExchange",
        params: {
          description,
        },
      });
    },
    sendTracker(eventLabel) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": 3,
      });
    },
  },
};
</script>

<style lang="scss">
.finishingScreen {
  width: 100%;
  height: 100%;
  display: flex;

  .slick-dots li {
    margin: 0;
  }
  .slick-dots li button:before {
    font-size: 10px;
    margin: 0;
  }

  .slick-dots button:before {
    color: #bababa !important;
  }

  .slick-dots .slick-active button:before {
    color: #0026d9 !important;
  }

  // position: absolute;
  .change_chip_container {
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
    width: 90%;
    margin: 0 5%;
    // align-items: center;
    box-sizing: content-box;
    > img {
      margin-top: 42px;
    }
  }
  .finishingScreenPage_title {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-block-end: 0 !important;
    margin-top: 88px;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    text-align: center;
    color: #000000;
    align-self: center;
  }
  .change_chip_carousel {
    margin-bottom: 56px;
  }
  .barcode_inst_infos {
    width: 309px;
    min-height: 48px;
    margin: 42px auto 33px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > img {
      height: auto;
      margin: auto;
      margin-bottom: 32px;
    }
    > span {
      width: 309px;
      height: 48px;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }
  .registered_info {
    width: 309px;
    height: 48px;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    align-self: center;
    > .description_info {
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #000000;
    }
  }
  .time_page_info {
    width: 309px;
    height: 48px;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    align-self: center;
    > .description_time_page {
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
      text-align: center;
    }
  }
  .description_info {
    width: 309px;
    height: auto;
    font-family: "timsans_bold";
    display: block;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: center;
    color: #000000;
  }
  .finishingScreenPage_container-button {
    width: 100%;
    height: auto;
    margin-top: 28px;
    position: fixed;
    bottom: 0;
    justify-content: center;
    display: grid;
    align-items: center;
  }
  .finishingScreenPage_button {
    width: 286px;
    height: 52px;
    margin: 0 auto 24px auto;
    border-radius: 26px;
    border: solid 2px #003091;
    background: none;
    outline: none;
    font-size: 1em;
    text-align: center;
    color: #003091;
    &:hover {
      cursor: pointer;
      -webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      -moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
      transition: 1s;
    }
  }
  .finishingScreenPage_subtitle {
    width: 309px;
    min-height: 48px;
    margin: 16px auto 23px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > span {
      width: 309px;
      height: 48px;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }

  .progress_line {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .timer {
    font-family: "timsans_bold";
    font-size: 16px;
    color: #ffffff;
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
  }

  .progress_line_blue {
    width: 0; /* Inicialmente, a largura é zero */
    height: 4px;
    display: flex;
    padding: 1px;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    position: relative;
    background-color: #0026d9;
    overflow: hidden;
    margin-top: 1.5rem;
  }

  @keyframes growWidth {
    to {
      width: 100%; /* A largura atinge 100% após 15 segundos */
    }
  }
}
</style>
